import * as React from 'react';

import { useLeapState } from '../hooks/useLeapState';
import { useLeapData } from '../hooks/useLeapData';

import Content, { Filter, Result, Item } from '../components/blueprints/core/Content';

import Grid from '../components/controls/grid/Grid';
import Section from '../components/controls/grid/Section';
import Row from '../components/controls/grid/Row';

import Text from '../components/controls/Text';

import BranchResultList from '../features/branch/BranchResultList';
import ComboBox from '../components/controls/ComboBox';

export default () => {
    const controller = "Branch"
    const page = useLeapState(controller)

    const code = useLeapData("code", "codice", page)
    const description = useLeapData("description", "descrizione", page)

    const dentalElementStatePrevious = useLeapData("leap_DentalElementStatePreviousId", "stato precedente", page, "dentalStates")
    const dentalElementStateNext = useLeapData("leap_DentalElementStateNextId", "stato successivo", page, "dentalStates")
    
    const medicalSpecialtyTypeId = useLeapData("medicalSpecialtyTypeId", "specialità", page, "medicalSpecialtyType")

    const [dentalElementStatePreviousValue, setDentalElementStatePreviousValue] = React.useState<any>()
    const dentalElementStatePreviousOnChange = (name: string | undefined, value: string | number | undefined, required?: boolean | undefined) => {
        setDentalElementStatePreviousValue(value)
    }

    React.useEffect(() => {
        setDentalElementStatePreviousValue(page.item?.state?.data?.leap_DentalElementStatePreviousId)
    }, [page.item?.state?.data?.leap_DentalElementStatePreviousId])

    const [dentalElementStateNextValue, setDentalElementStateNextValue] = React.useState<any>()
    const dentalElementStateNextOnChange = (name: string | undefined, value: string | number | undefined, required?: boolean | undefined) => {
        setDentalElementStateNextValue(value)
    }

    React.useEffect(() => {
        setDentalElementStateNextValue(page.item?.state?.data?.leap_DentalElementStateNextId)
    }, [page.item?.state?.data?.leap_DentalElementStateNextId])


    return <>
        <Content title="Branca" controller={controller}>
            <Filter>
                <Grid>
                    <Section toolbar="filter">
                        <Row>
                            <Text {...code} className="ms-sm2" />
                            <Text {...description} className="ms-sm10" />
                        </Row>
                        <Row>
                            <ComboBox {...medicalSpecialtyTypeId} className="ms-sm4" />
                        </Row>
                    </Section>
                </Grid>
            </Filter>
            <Result>
                <Grid>
                    <Section toolbar="result" controller={controller}>
                        <BranchResultList controller={controller} items={page.result?.state?.data} />
                    </Section>
                </Grid>
            </Result>
            <Item>
                <Grid>
                    <Section toolbar="item" controller={controller}>
                        <Row>
                            <Text {...code} className="ms-sm2" readOnly={page.modality === "item"} required />
                            <Text {...description} className="ms-sm10" required />
                        </Row>
                        <Row>
                            <ComboBox {...dentalElementStatePrevious} className="ms-sm6" onChange={dentalElementStatePreviousOnChange} hidden={medicalSpecialtyTypeId.value != 1} selectedKey={dentalElementStatePreviousValue} />
                            <ComboBox {...dentalElementStateNext} className="ms-sm6" required={!!page.item?.values?.leap_DentalElementStatePreviousId?.value} hidden={medicalSpecialtyTypeId.value != 1} onChange={dentalElementStateNextOnChange} selectedKey={dentalElementStateNextValue} />
                        </Row>
                        <Row>
                            <ComboBox {...medicalSpecialtyTypeId} className="ms-sm4" disabled={page.modality === "item"} required/>
                        </Row>
                    </Section>
                </Grid>
            </Item>
        </Content>
    </>
};
